export const IMPORT_FIELDS = [
  ["name", "Client name"], ["contact", "Contact person"], ["phone", "Phone"],
  ["email", "Email"], ["address", "Address"], ["email_reports", "Email job reports (yes/no)"],
];
const JOIN = { name: " ", contact: " ", address: ", " };
const NO = new Set(["no", "n", "false", "0", "off"]);

// Excel drops the leading 0 from Australian numbers saved as numbers (412 345 678).
export const fixPhone = (v) => (/^[23478]\d{8}$/.test(v) ? `0${v}` : v);
export const badEmail = (v) => !!v && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v);

// Turns spreadsheet rows into clients using the column -> field choices. Rows without a name are left out.
export const buildClients = (rows, map) => rows.map((row) => {
  const f = {};
  IMPORT_FIELDS.forEach(([k]) => {
    const vals = [...new Set(map.flatMap((m, i) => (m === k && row[i] ? [row[i]] : [])))];
    f[k] = JOIN[k] ? vals.join(JOIN[k]) : vals[0] || "";
  });
  return { ...f, phone: fixPhone(f.phone), email_reports: !NO.has(f.email_reports.toLowerCase()) };
}).filter((c) => c.name);

const TEMPLATE = "name,contact,phone,email,address,email_reports\r\n"
  + "Coastline Homes,Jess Murray,0412 345 678,accounts@coastline.com.au,\"12 Banksia Cres, Armstrong Creek VIC 3217\",yes\r\n";

export const downloadTemplate = () => {
  const url = URL.createObjectURL(new Blob([TEMPLATE], { type: "text/csv" }));
  const a = Object.assign(document.createElement("a"), { href: url, download: "clients-template.csv" });
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
